import jsPDF from "jspdf";
import "jspdf-autotable";
import html2canvas from "html2canvas";
import "../../styles/downloadInvoice.css";
import { OrderVeiwApi } from "../../services/apiService";

export const downloadInvoice = async (orderId, logo, address) => {
  try {
    console.log(orderId, "orderId");

    const token = localStorage.getItem("token");
    const response = await OrderVeiwApi(orderId, token);
    if (response.status_code === 200) {
      const orderDetail = response.data;
      // Create the invoice HTML element
      const invoiceElement = document.createElement("div");
      invoiceElement.style.width = "100%";
      invoiceElement.style.maxWidth = "240mm";
      invoiceElement.style.padding = "10mm";
      invoiceElement.style.boxSizing = "border-box";
      invoiceElement.style.fontSize = "14px";
      invoiceElement.style.margin = "auto";
      invoiceElement.style.backgroundColor = "#fff";

      invoiceElement.innerHTML = `
           
         <div class="invoice-header">
        <div class="company-info">
          <div class="company-logo">
            <img
              src=${logo}
              alt="Company Logo"
            />
          </div>
    
          <p>${address}</p>
         
          <div class="user-details">
            <p
              class="address-header bold"
               style="padding-bottom: 15px; font-size: 16px;"
            >
              BILLING ADDRESS
            </p>
            <p>
              <span class="email"> Name:</span>
              ${orderDetail?.billing_address?.billing_name}
            </p>
            <p>
              <span class="email"> Phone:</span>
              ${orderDetail?.billing_address?.billing_phone_no}
            </p>
            <p>
              <span class="email"> Email:</span>
              ${orderDetail?.billing_address?.billing_email}
            </p>
            <p>
              <span class="email"> Address:</span>
              ${orderDetail?.billing_address?.billing_address_line_one}, ${
        orderDetail?.billing_address?.billing_address_line_two
      } 
            </p>
            <p>
              <span class="email"> City:</span>
              ${orderDetail?.billing_address?.billing_city}
            </p>
            <p>
              <span class="email"> State:</span>
              ${orderDetail?.billing_address?.billing_state}
            </p>
            <p>
              <span class="email"> Country:</span>
              ${orderDetail?.billing_address?.billing_country}
            </p>
            <p>
              <span class="email"> Pincode:</span>
              ${orderDetail?.billing_address?.billing_pincode}
            </p>
          </div>
        </div>

        <div class="invoice-details">
          <p class="invoice-title">INVOICE</p>
          <p>
            Order No: <span class="bold">${orderDetail?.order_code || ""}</span>
          </p>

          <p>
            Order Date:
            <span class="bold">${orderDetail?.order_date || ""}</span>
          </p>
          <p>
            Order Status:
            <span class="bold">${orderDetail?.order_status || ""}</span>
          </p>
          <p>
            Mode of Payment:
            <span class="bold">
            ${orderDetail?.mode_of_payment || "Manual Payment"}
            </span>
          </p>
          <p>
            Payment Status:
            <span class="bold">${orderDetail?.payment_status || ""}</span>
          </p>
          <div class="user-details">
            <p class="address-header bold">SHIPPING ADDRESS</p>

            <p>
              <span class="email"> Name:</span>
              ${orderDetail?.shipping_address?.shipping_name}
            </p>
            <p>
              <span class="email"> Phone:</span>
              ${orderDetail?.shipping_address?.shipping_phone_no}
            </p>
            <p>
              <span class="email"> Email:</span>
              ${orderDetail?.shipping_address?.shipping_email}
            </p>
            <p>
              <span class="email"> Address:</span>
              ${orderDetail?.shipping_address?.shipping_address_line_one}, ${
        orderDetail?.shipping_address?.address_line_two
      }
            </p>
            <p>
              <span class="email"> City:</span>
              ${orderDetail?.shipping_address?.shipping_city}
            </p>
            <p>
              <span class="email"> State:</span>
              ${orderDetail?.shipping_address?.shipping_state}
            </p>
            <p>
              <span class="email"> Country:</span>
              ${orderDetail?.shipping_address?.shipping_country}
            </p>
            <p>
              <span class="email"> Pincode:</span>
              ${orderDetail?.shipping_address?.shipping_pincode}
            </p>
          </div>
        </div>
      </div>
        
      `;

      document.body.appendChild(invoiceElement);

      const canvas = await html2canvas(invoiceElement, {
        scale: 2,
        useCORS: true,
        logging: true,
      });

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const imgWidth = pdfWidth;
      const imgHeight = (canvas.height * pdfWidth) / canvas.width;

      pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);

      const tableData =
        orderDetail?.purchase_list?.map((product) => [
          product.product_name,
          product.quantity,
          `Rs.${product.price}`,
          `Rs.${product.discount_price}`,
          `Rs.${product.tax_amount}`,
          `Rs.${product.sales_amount}`,
        ]) || [];

      pdf.autoTable({
        startY: imgHeight + 2,
        head: [
          [
            "Product Name",
            "Quantity",
            "Price",
            "Discount Price",
            "Tax Amount",
            "Sales Amount",
          ],
        ],
        body: tableData,
        theme: "striped",
        styles: {
          fontSize: 10,
          cellPadding: 4,
        },
      });

      const totalsData = [
        // ["","","","","","","Subtotal", `Rs.302324234`],
        // ["","","","","","","Discount", `Rs.30202`],
        // ["","","","","","","Tax Amount", `Rs.30202`],
        [
          "",
          "",
          "",
          "",
          "",
          "",
          "Total Amount",
          `Rs.${orderDetail?.total_amount}`,
        ],
      ];

      pdf.autoTable({
        startY: pdf.autoTable.previous.finalY + 3,
        body: totalsData,
        theme: "striped",
        styles: {
          fontSize: 10,
          cellPadding: 2,
        },
        columnStyles: {
          0: { cellWidth: 10 },
          1: { cellWidth: 10 },
          2: { cellWidth: 10 },
          3: { cellWidth: 40 },
          4: { cellWidth: 50 },
        },
      });
      pdf.setFont("DM", "bold");
      pdf.setFontSize(14);
      pdf.text("DECLARATION", 105, pdf.autoTable.previous.finalY + 10, {
        align: "center",
      });
      pdf.setFont("DM", "normal");

      pdf.setFontSize(10);
      pdf.text(
        "We declare that this invoice shows the actual price of the goods described and that all particulars are true and correct.",
        10,
        pdf.autoTable.previous.finalY + 20,
        { align: "left", maxWidth: 180 }
      );
      // const yPositionForBottomDesign = pdf.autoTable.previous.finalY + 30;

      // // Calculate half of the page width for the left and right sections
      // // const pdfWidth = pdf.internal.pageSize.width;
      // const leftSectionWidth = pdfWidth / 2;
      // const rightSectionWidth = pdfWidth / 2;
      // const gapBetweenSections = 5; // Gap between the two sections

      // // Draw the black section on the left side (black-section-bottom)
      // pdf.setFillColor(0, 0, 0); // black color
      // pdf.rect(10, yPositionForBottomDesign, leftSectionWidth - gapBetweenSections, 5, "F"); // Black rectangle on the left side

      // // Define red section heights
      // const redSmallHeight = 5;
      // const redMediumHeight = 7;
      // const redLargeHeight = 9;

      // // Draw the red sections on the right side (red-section-bottom)
      // pdf.setFillColor(255, 0, 0); // red color
      // pdf.rect(leftSectionWidth + gapBetweenSections, yPositionForBottomDesign, 30, redSmallHeight, "F"); // red-small-bottom

      // // Second red section (red-medium-bottom)
      // pdf.rect(leftSectionWidth + gapBetweenSections + 30, yPositionForBottomDesign, 60, redMediumHeight, "F"); // red-medium-bottom

      // // Third red section (red-large-bottom)
      // pdf.rect(leftSectionWidth + gapBetweenSections + 90, yPositionForBottomDesign, 90, redLargeHeight, "F"); // red-large-bottom

      // Save the PDF
      pdf.save("invoice.pdf");

      document.body.removeChild(invoiceElement);
    } else {
      console.error("Failed to fetch order details");
    }
  } catch (error) {
    console.error("Error fetching order details:", error);
  }
};
